
import { createApiClient } from 'Network/ApiClient';

export const ActivityFrequencyAxiosInstance = createApiClient('activityfrequency/');


